module.exports = __webpack_public_path__ + "img/room-popularity-award_ar.6126b789.png";